<template>
  <validation-observer
    v-slot="{touched}"
  >
    <div class="default-table shadow-none border-none table-compact">
      <b-table-simple
        responsive
        class="loaded"
        table-class="mt-0 mb-1"
      >
        <b-thead>
          <b-tr>
            <b-th>
              Key
            </b-th>
            <b-th>
              Value
            </b-th>
            <b-th />
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr>
            <b-td class="pb-0">
              <div>
                <b-form-input
                  value="Content-Type"
                  disabled
                  placeholder="Content Type"
                  class="mb-0"
                />
              </div>
            </b-td>
            <b-td class="pb-0">
              <validation-provider
                #default="{ errors }"
                name="Content Type"
                rules="required"
              >
                <b-form-input
                  v-model="metadata.contentType"
                  placeholder="Enter content type here..."
                  :state="errors.length > 0 ? false:null"
                  class="mb-0"
                />
              </validation-provider>
            </b-td>
          </b-tr>
          <b-tr>
            <b-td class="pb-0">
              <div>
                <b-form-input
                  value="Cache-Control"
                  disabled
                  placeholder="Cache Control"
                  class="mb-0"
                />
              </div>
            </b-td>
            <b-td class="pb-0">
              <validation-provider
                #default="{ errors }"
                name="Cache Control"
                rules="required"
              >
                <b-form-input
                  v-model="metadata.cacheControl"
                  placeholder="Enter cache control here..."
                  :state="errors.length > 0 ? false:null"
                  class="mb-0"
                />
              </validation-provider>
            </b-td>
          </b-tr>
          <b-tr>
            <b-td class="pb-0">
              <div>
                <b-form-input
                  value="Content-Encoding"
                  disabled
                  placeholder="Content Encoding"
                  class="mb-0"
                />
              </div>
            </b-td>
            <b-td class="pb-0">
              <validation-provider
                #default="{ errors }"
                name="Content Encoding"
                rules="required"
              >
                <b-form-input
                  v-model="metadata.contentEncoding"
                  placeholder="Enter content encoding here..."
                  :state="errors.length > 0 ? false:null"
                  class="mb-0"
                />
              </validation-provider>
            </b-td>
          </b-tr>
          <b-tr>
            <b-td class="pb-0">
              <div>
                <b-form-input
                  value="Content-Disposition"
                  disabled
                  placeholder="Content Disposition"
                  class="mb-0"
                />
              </div>
            </b-td>
            <b-td class="pb-0">
              <validation-provider
                #default="{ errors }"
                name="Content Disposition"
                rules="required"
              >
                <b-form-input
                  v-model="metadata.contentDisposition"
                  placeholder="Enter content disposition here..."
                  :state="errors.length > 0 ? false:null"
                  class="mb-0"
                />
              </validation-provider>
            </b-td>
          </b-tr>
          <b-tr
            v-for="item in customPairings"
            :key="item.id"
          >
            <b-td class="pb-0">
              <validation-provider
                #default="{ errors }"
                name="Key"
                rules="required"
              >
                <b-input-group
                  prepend="x-amz-meta-"
                >
                  <b-form-input
                    v-model="item.key"
                    placeholder="Enter key here..."
                    :state="errors.length > 0 ? false:null"
                    class="mb-0"
                  />
                </b-input-group>

              </validation-provider>

            </b-td>
            <b-td class="pb-0">
              <validation-provider
                #default="{ errors }"
                name="Value"
                rules="required"
              >
                <b-form-input
                  v-model="item.value"
                  placeholder="Enter value here..."
                  :state="errors.length > 0 ? false:null"
                  class="mb-0"
                />
              </validation-provider>

            </b-td>

            <b-td
              class="pb-0"
              variant="one-button"
            >
              <span
                class="cursor-pointer"
                @click="removeMetadata(item.id)"
              >
                <GjIcon name="Delete" />
              </span>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <div class="d-flex justify-content-between w-100 px-1 py-2">
        <a
          class="text-primary cursor-pointer"
          @click="addNewMetadata"
        >
          + Add custom pairing
        </a>
        <button-loading
          variant="primary"
          :spinning="updatingObject"
          :disabled="!touched || updatingObject"
          @click="saveMetadata"
        >
          Save
        </button-loading>
      </div>
    </div>
  </validation-observer>

</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { v4 as uuidv4 } from 'uuid'

import helpers from '@/mixins/helpers'

export default {
  name: 'FileMetadata',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [helpers],
  props: {
    file: {
      type: Object,
      default: null,
      required: true,
    },
    accountId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      required,
      customPairings: [],
      fetchingMetadata: false,
      savingMetadata: false,
      metadata: {
        cacheControl: 'string',
        contentDisposition: 'string',
        contentEncoding: 'string',
        contentType: 'string',
        metadata: {
          additionalProp1: 'string',
          additionalProp2: 'string',
          additionalProp3: 'string',
        },
      },
    }
  },
  computed: {
    updatingObject() {
      return this.$store.state.accountObjects.updatingObject
    },
  },
  watch: {
    file() {
      this.getMetadata()
    },
  },
  created() {
    this.getMetadata()
  },
  methods: {
    prepareQuery() {
      const obj = { ...this.metadata }
      obj.metadata = {}
      this.customPairings.forEach(pair => {
        obj.metadata[`x-amz-meta-${pair.key}`] = pair.value
      })
      return obj
    },
    saveMetadata() {
      const query = this.prepareQuery()
      this.settingPermission = true
      this.$store.dispatch('accountObjects/updateObject', {
        accountId: this.accountId,
        query,
      }).then(() => {
        this.successToast('Metadata updated successfully.')
        this.$emit('refresh')
      }).catch(() => {
        this.errorToast('Error updating metadata.')
      })
    },
    getMetadata() {
      this.metadata = { ...this.file }
      const keys = Object.keys(this.metadata.metadata)
      this.customPairings = keys.map(key => ({ key: key.replace('x-amz-meta-', ''), value: this.metadata.metadata[key], id: uuidv4() }))
    },
    addNewMetadata() {
      this.customPairings = [...this.customPairings, {
        key: '',
        value: '',
        id: uuidv4(),
      }]
    },
    removeMetadata(id) {
      this.customPairings = this.customPairings.filter(cp => cp.id !== id)
    },
  },
}
</script>

<style>

</style>
